import Component from './Component'
import { BracketsRegex, RemoveBrackets, ValidateCondition } from './utils'
import { path } from 'ramda'

function getValidatorConfig(schema, data = {}, options = {}) {
  const { prefix } = options

  return {
    labels: schema.reduce((res, cur) => {
      if (!cur.label) return res

      let isList = Boolean(cur.component.match(BracketsRegex))
      let targetData = path(cur.key.split('.'), data) || []

      if (!cur.component.includes(':')) {
        if (isList)
          targetData.forEach(
            (e, i) =>
              (res[[prefix, cur.key, i].filter(e => e !== undefined).join('.')] = cur.label),
          )
        else res[[prefix, cur.key].filter(e => e !== undefined).join('.')] = cur.label
      } else
        RemoveBrackets(cur.component)
          .split(',')
          .forEach(config => {
            let [component, key, label] = RemoveBrackets(config).split(':')
            if (!label) return

            let isSublist = config.match(BracketsRegex)

            if (isList)
              targetData.forEach((e, i) => {
                if (isSublist) {
                  let subtargetData = path(key.split('.'), targetData[i]) || []
                  subtargetData.forEach(
                    (e, ii) =>
                      (res[[prefix, cur.key, i, key, ii].filter(e => e !== undefined).join('.')] =
                        label),
                  )
                } else res[[prefix, cur.key, i, key].filter(e => e !== undefined).join('.')] = label
              })
            else {
              if (isSublist) {
                let subtargetData = path(key.split('.'), targetData) || []
                subtargetData.forEach((e, ii) => (res[[cur.key, key, ii].join('.')] = label))
              } else res[[prefix, cur.key, key].filter(e => e !== undefined).join('.')] = label
            }
          })

      return res
    }, {}),
    rules: schema.reduce((res, cur) => {
      if (!cur.options || !cur.options.validation) return res

      let isList = Boolean(cur.component.match(BracketsRegex))

      if (
        typeof cur.options.validation === 'string' &&
        ValidateCondition(path(['options', 'condition'], cur), cur.component, data)
      )
        res[[prefix, cur.key, isList ? '*' : false].filter(Boolean).join('.')] =
          cur.options.validation
      else
        Object.entries(cur.options.validation).forEach(([key, value]) => {
          if (
            !ValidateCondition(
              path(['options', 'condition', '*'], cur) || path(['options', 'condition', key], cur),
              undefined,
              data,
            )
          )
            return
          let target = cur.component.split(',').find(c => {
            let [, k] = RemoveBrackets(c).split(':')
            return k === key
          })
          res[
            [
              prefix,
              cur.key,
              isList ? '*' : false,
              key,
              target && Boolean(target.match(BracketsRegex)) ? '*' : false,
            ]
              .filter(Boolean)
              .join('.')
          ] = value
        })

      return res
    }, {}),
  }
}

export { getValidatorConfig }
export default Component
